<template>
  <div class="p-grid">
    <div class="p-col-1">
      <span>From</span>
    </div>
    <div class="p-col-5">
      <Calendar v-model="fieldValue1" :dateFormat="dateFormat()" :showIcon="false" :disabled="disabled"/>
    </div>
    <div class="p-col-1">
      <span>To</span>
    </div>
    <div class="p-col-5">
      <Calendar v-model="fieldValue2" :dateFormat="dateFormat()" :showIcon="false" :disabled="disabled"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {dateFormatHelper} from "@/helpers/datehelpers";

export default {
  name: "DynamimicTimeSpan",
  props: ['uniqueId', 'disabled'],
  data() {
    return {
      fieldValue1: '',
      fieldValue2: ''
    }
  },
  computed: {
    ...mapGetters('search', [
      'getData'
    ]),
  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),
    dateFormat: dateFormatHelper,
    load() {
      let data = this.getData(this.uniqueId);
      if (data[0] != null && data[0] !== undefined && data[0] !== "") {
        this.fieldValue1 = new Date(Date.parse(data[0]))
      } else {
        this.fieldValue1 = '';
      }
      if (data[1] != null && data[1] !== undefined && data[1] !== "") {
        this.fieldValue2 = new Date(Date.parse(data[1]))
      } else {
        this.fieldValue2 = '';
      }
    },
    set() {
      let resData = [];
      console.log(this.fieldValue1);
      if (this.fieldValue1 != null && this.fieldValue1 !== "") {
        let date = new Date(Date.UTC(this.fieldValue1.getFullYear(), this.fieldValue1.getMonth(), this.fieldValue1.getDate()))
        resData.push(date.toISOString().split('T')[0]);
        if (this.fieldValue2 != null && this.fieldValue2 !== "") {
          let date = new Date(Date.UTC(this.fieldValue2.getFullYear(), this.fieldValue2.getMonth(), this.fieldValue2.getDate()))
          resData.push(date.toISOString().split('T')[0]);
        }
      }
      let call = {uniqueId: this.uniqueId, data: resData};
      this.setData(call);
    }
  },
  mounted() {
    this.load();

    console.log(Intl);

  },
  watch: {
    fieldValue1: function () {
      this.set();
    },
    fieldValue2: function () {
      this.set();
    }
  }
}
</script>

<style scoped>

</style>